/**
 * ---------------------------------------------------------------------------------------------------------
 * File này sẽ khai báo toàn bộ "CONST" | "INTERFACE" cho phần kết nối với API -----------------------------
 * ---------------------------------------------------------------------------------------------------------
 * @author admin
 * */


/*
 * Authentication -------------------------------------------------------------------------------------------
 * */
export const REQUEST_HEADER_AUTHORIZATION = 'Authorization'; // token value
export const REQUEST_HEADER_APP_VERSION = 'App-Version'; // version app value


/*
 * Common -------------------------------------------------------------------------------------------------
 * */
export enum HEADER_STATUS_CODE {
  FOUND = 302,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}

export const ERROR_CODE = {
  ERR_REQUIRED_TOKEN: 'ERR_REQUIRED_TOKEN',
  ERR_INVALID_TOKEN: 'ERR_INVALID_TOKEN',
  ERR_REQUIRED_FORM_DATA: 'ERR_REQUIRED_FORM_DATA',
  ERR_INVALID_FORM_FIELDS: 'ERR_INVALID_FORM_FIELDS',
  ERR_PAGE_401: 'ERR_PAGE_401',
  ERR_403: 'ERR_403',
  ERR_PAGE_404: 'ERR_PAGE_404',
  ERR_DATA_404: 'ERR_DATA_404',
  ERR_INVALID_DATA: 'ERR_INVALID_DATA',
  ERR_INVALID_PARAMS: 'ERR_INVALID_PARAMS',
  ERR_INVALID_RESPONSE: 'ERR_INVALID_RESPONSE',
  ERR_NETWORK: 'ERR_NETWORK',
  ERR_EXCEPTION: 'ERR_EXCEPTION',
  ERR_B403: 'ERR_B403',
  ERR_PSC_401: 'ERR_PSC_401',
  ERR_INVALID_BUSINESS_ID: 'ERR_INVALID_BUSINESS_ID',
  ERR_INVALID_ACCESS_TOKEN: 'ERR_INVALID_ACCESS_TOKEN',
  ERR_INVALID_PAGE_ID: 'ERR_INVALID_PAGE_ID',
}

export const API_NHANH_KEY = {
  businessId: 'businessId',
  nuctk: 'nuctk',
  pageSize: 'icpp',

  /** @TODO NVN DungMV em xem đổi các phần liên quan chốt dùng 1 kiểu elPage thôi */
  EL_PAGE: 'next',
  EL_SIZE: 'size',
}
